export default "/images/vendor/flag-icons/flags/1x1/mf.svg?4b4f663eb5e16690ef4aa18306d8601f";